import { RpiTable } from "../../rpi-core/table/RpiTable";
import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { useAuthUser } from "../../hooks/useAuthUser";
import { Menu } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import {
  customerProductColumnsSuperAdmin,
  customerProductColumnsV2,
} from "../../configuration/columns/customerProductV2.column";
import { createRpaTableMenuColumn, RpaTableMenu } from "../../components/RpaTableMenu";
import { RpiTableV2Container, RpiTableFooter } from "../../components/RpiTableV2Container";
import React from "react";

type CustomerProductsType = GraphQLPagedQueryData<GraphQL.CustomerProductsQuery>;
type CustomerProductsSuperAdminType = GraphQLPagedQueryData<GraphQL.CustomerProductsSuperAdminQuery>;

export interface CustomerProductsTableV2Props {
  customerProducts?: (CustomerProductsType | CustomerProductsSuperAdminType)[];
  isLoading: boolean;
  error?: unknown;
  setIsPriceCalculatorOpen: (open: boolean) => void;
  setProductId: (id: number | undefined) => void;
}

export function CustomerProductsTableV2({
  customerProducts,
  isLoading,
  error,
  setIsPriceCalculatorOpen,
  setProductId,
  children,
}: React.PropsWithChildren<CustomerProductsTableV2Props>) {
  const user = useAuthUser();
  const columnDefs = user.is.SUPER_ADMIN ? customerProductColumnsSuperAdmin : customerProductColumnsV2;

  return (
    <RpiTableV2Container>
      <RpiTable
        variant="normalV2"
        isLoading={isLoading}
        error={error}
        emptyMessage={"No products found."}
        perPage={customerProducts?.length}
        data={customerProducts}
        columns={columnDefs}
        additionalColumns={[
          createRpaTableMenuColumn<CustomerProductsType | CustomerProductsSuperAdminType>((row) => (
            <ProductsActionMenu
              onOpenPriceCalculator={() => {
                setProductId(row.id);
                setIsPriceCalculatorOpen(true);
              }}
            />
          )),
        ]}
      />
      {children}
    </RpiTableV2Container>
  );
}

export function CustomerProductsTableFooter({ children }: React.PropsWithChildren) {
  return <RpiTableFooter>{children}</RpiTableFooter>;
}

type ProductsActionMenuProps = {
  onOpenPriceCalculator: () => void;
};
function ProductsActionMenu({ onOpenPriceCalculator }: ProductsActionMenuProps) {
  return (
    <RpaTableMenu>
      <Menu.Item icon={<IconV3 icon="attach_money" size={20} />} onClick={onOpenPriceCalculator}>
        Price Calculator
      </Menu.Item>
    </RpaTableMenu>
  );
}
